import React from 'react';
import './PrivacyModel.css';

const RefundModel = ({ show, onClose }) => {
  if (!show) return null;

  return (
    <div className="privacy-model-overlay" onClick={onClose}>
      <div className="privacy-model-content" onClick={(e) => e.stopPropagation()}>
        <div className="privacy-model-header">
          <h2>Refund Policy</h2>
          <button className="privacy-model-close" onClick={onClose}>
            ×
          </button>
        </div>
        
        <div className="privacy-model-body">
          <div className="privacy-section">
            <p>At ResumeGlobe, we aim to help you create the best resume possible. We understand that sometimes things don't go as planned, and we want to ensure you're satisfied with your experience. Please review our refund policy below:</p>
          </div>

          <div className="privacy-section">
            <h3>1. Eligibility for Refunds</h3>
            <p>Refunds are available under the following circumstances:</p>
            
            <h4>a. Technical Issues:</h4>
            <p>If you experience technical difficulties with the platform (e.g., the website doesn't function correctly, or your resume is not generated properly), please contact our support team at <strong>support@resumeglobe.com</strong>. We will attempt to resolve the issue first; if we cannot, a refund may be issued within 7 days of purchase.</p>

            <h4>b. Duplicate Charges:</h4>
            <p>If you were mistakenly charged twice for the same purchase, a full refund will be issued once we verify the duplicate transaction.</p>

            <h4>c. Purchase Mistake:</h4>
            <p>If you accidentally purchased the wrong subscription or service (e.g., buying a Platinum Plan when you intended to purchase a Gold Plan), we may offer a partial refund or adjust the service if the request is made within 48 hours of purchase.</p>
            <p>If any resumes have been downloaded, a preparation fee & platform fee will be deducted for services already rendered.</p>
          </div>

          <div className="privacy-section">
            <h3>2. Non-Refundable Services</h3>
            <p>Due to the nature of digital products and services, the following are non-refundable:</p>
            <ul>
              <li>Once you've created and downloaded your resume, it is considered a final product and no refund will be issued. (Eg; Silver Plan)</li>
              <li>Subscription Plans: If you've subscribed to our weekly or annual plans, you may cancel at any time, but partial refunds may be adjusted after deducting the preparation and platform fees for services already used.</li>
            </ul>
          </div>

          <div className="privacy-section">
            <h3>3. Non-Refundable Cases</h3>
            <p>We do not issue refunds in the following situations:</p>
            <ul>
              <li>You changed your mind after completing the payment.</li>
              <li>You failed to use the service due to personal reasons unrelated to our platform's performance.</li>
              <li>You did not read the product/service description properly before purchasing.</li>
            </ul>
          </div>

          <div className="privacy-section">
            <h3>4. How to Request a Refund</h3>
            <p>If you are eligible for a refund, please follow the steps below:</p>
            <ul>
              <li>Contact Us: Send an email to <strong>support@resumeglobe.com</strong> with the subject line "Refund Request".</li>
              <li>Include the following in your email:
                <ul>
                  <li>Order Number</li>
                  <li>Payment Date or Payment Reference</li>
                  <li>Plan Name</li>
                  <li>Description of the issue.</li>
                </ul>
              </li>
            </ul>
            <p>These information can be found in the payment receipt received in your registered email address.</p>
          </div>

          <div className="privacy-section">
            <h3>5. Response & Processing Time</h3>
            <ul>
              <li>Response Time: Our team will respond within 24–48 hours to assess your request.</li>
              <li>Refund Processing Time: If approved, your refund will be issued within 7 business days via the original payment method.</li>
              <li>Business days are Monday to Friday. Public holidays are excluded.</li>
            </ul>
          </div>

          <div className="privacy-section">
            <h3>6. Refund Method</h3>
            <p>Refunds will be processed to the original payment method used at the time of purchase.</p>
            <p>If you paid by credit card, please allow 5–10 business days for the refund to reflect on your statement, depending on your bank's processing time.</p>
          </div>

          <div className="privacy-section">
            <h3>7. Late or Missing Refunds</h3>
            <p>If you haven't received a refund yet:</p>
            <ul>
              <li>First, recheck your bank statement or credit card account.</li>
              <li>Then contact your payment provider—sometimes it may take time to process your refund request.</li>
              <li>If you've done all of this and still haven't received your refund, please contact us again at <strong>support@resumeglobe.com</strong>.</li>
            </ul>
          </div>

          <div className="privacy-section">
            <h3>8. Abuse and Fair Use</h3>
            <p>We reserve the right to decline refund requests from users who have:</p>
            <ul>
              <li>Misused or attempted to exploit the refund policy repeatedly</li>
              <li>Submitted false or misleading refund claims</li>
              <li>Are found violating our platform's Terms & Conditions</li>
            </ul>
          </div>

          <div className="privacy-section">
            <h3>9. Force Majeure</h3>
            <p>We are not liable for refund claims caused by events beyond our reasonable control, including but not limited to:</p>
            <ul>
              <li>Natural disasters</li>
              <li>Internet outages</li>
              <li>Third-party service disruptions</li>
              <li>Power failures</li>
              <li>Government restrictions.</li>
            </ul>
          </div>

          <div className="privacy-section">
            <h3>10. Third-Party Services</h3>
            <p>If your transaction or service includes third-party integrations (e.g., payment gateways, third-party course providers, or affiliate tools), please note:</p>
            <ul>
              <li>Refund timelines and eligibility may be subject to the policies of those third-party platforms</li>
              <li>ResumeGlobe is not responsible for delays or denials caused by external providers</li>
            </ul>
          </div>

          <div className="privacy-section">
            <h3>11. Contact Information</h3>
            <p>For all inquiries and support:</p>
            <ul>
              <li>Email: <strong>support@resumeglobe.com</strong></li>
            </ul>
          </div>

          <div className="privacy-section">
            <h3>Important Notes</h3>
            <p>By using ResumeGlobe, you agree to the terms outlined in this refund policy.</p>
            <p>This policy is subject to change at any time. Please revisit this page periodically to stay informed of any updates.</p>
            <p><strong>Last Updated: Aug 10, 2025.</strong></p>
          </div>
        </div>
        
        <div className="modal-footer">
          <button className="btn-close-modal" onClick={onClose}>Close</button>
        </div>
      </div>
    </div>
  );
};

export default RefundModel;
